<template>
  <OffersGroups
    :bid_groups="groups"
    :bids="modified_items"
    :critery-card="criteryCard"
    :tender="tender"
    without_select/>
</template>

<script>
import OffersGroups from 'components/tenders/tender page/OffersGroups.vue'

import { TenderFile } from '@/types/commonFile.js'
import { modalMixin } from 'mixins'

export default {
  name: 'bidHistoryPrequalification',
  mixins: [ modalMixin],
  data() {
    return {
      criteryCard: null,
      currencies: []
    }
  },
  props: {
    items: Array,
    tender: Object
  },
  async created() {
    await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard}).then(res => this.criteryCard = res)
    await this.$store.dispatch('setCurrencies')
      .then(res => this.currencies = res)
  },
  computed: {
    groups() {
      return [{items: this.modified_items, winners: true, formatHeaders: this.formatHeaders}]
    },
    modified_items() {
      let new_arr = this.items.map((item, n) => {
        let  mapDocs = (docs) => {
          if ( docs?.length ) {
            return docs?.map(file => file.id ? new TenderFile(this.tender.tenderId, file.id, file.key, null, file.title, file.size) : file )
          } else {
            return []
          }
        }

        item.bidDetailView.criteria.forEach(item => item.attachments = mapDocs(item.attachments) )

        let res = {
          ...item,
          ...item.bidDetailView,
          attachments: mapDocs(item.attachments),
          bidderInfo: item.bidderInfoView,
          index: item.bidderInfoView?.usreou + '' + item.bidDetailView?.lotId + '' + n,
          currencyTitle: this.getCurrency(item),
          lotTitle: this.findLot(item.bidDetailView.lotId),
          name: item.bidderInfo?.organizationName
        }
        return res
      })
      return new_arr
    },
  },
  methods: {
    findLot(id) {
      return this.tender.lots.find(lot => lot.lotId == id)?.title
    },
    formatHeaders(headers) {
      if ( this.tender.tenderStatus?.id != 5 ) {
        headers.splice(-1, 0,
          { text: this.$t('Purchasing.Status'), value: 'status', sortable: false, width: '1.5'  } )
      }
      return headers
    },
  },
  components: {
    OffersGroups
  }
}
</script>
